import { csmHubSetupSupportWebsiteResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupSupportWebsiteResource.tsx';
import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { csmBaseUrlResource } from '@jira/router-resources__service-desk-customer-service-csm-base-url/src/csmBaseUrlResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { serviceDeskAnalyticsContextResource } from '@jira/router-resources__service-desk-analytics-context/src/useServiceDeskAnalyticsContext.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsSupportWebsiteOverviewRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsSupportWebsiteOverviewRoute.tsx';
import { AsyncSupportWebsiteNav } from '@jira/navigation-apps__horizontal-nav-csm-support-website/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import {
	HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
	HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation,
} from './ui/support-website-overview/index.tsx';

export const helpCenterSettingsSupportWebsiteOverviewRouteEntry: Route = createEntry(
	helpCenterSettingsSupportWebsiteOverviewRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.support-website.overview',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			horizontal: fg('csm_contact_us_rte') ? undefined : AsyncSupportWebsiteNav,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		entryPoint: () =>
			fg('csm_contact_us_rte')
				? HelpCenterSettingsSupportWebsiteOverviewAppEntryPointWithHorizontalNavigation
				: HelpCenterSettingsSupportWebsiteOverviewAppEntryPoint,
		resources: [
			...getServiceDeskNavigationResources(),
			serviceDeskContextResource,
			serviceDeskAnalyticsContextResource,
			csmBaseUrlResource,
			csmHubSetupSupportWebsiteResource,
			customerExperiencesNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
